// @flow
import React, { Component } from "react";
import { HashRouter as Router } from "react-router-dom";

import { THEME_BKG } from "./commons/theme";

import Header from "./Header";
import Terroir from "./Terroir";
import Boutique from "./Boutique";
import Histoire from "./Histoire";
import References from "./References";
import Contact from "./Contact";

type Props = {};

let BKG = THEME_BKG;
const overload = /bkg=([a-zA-Z0-9]+)/.exec(location.search); // eslint-disable-line
if (overload && overload[1]) {
  BKG = "#" + overload[1];
}

class App extends Component<Props> {
  render() {
    return (
      <Router>
        <div
          style={{
            backgroundColor: BKG,
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            overflow: "auto",
          }}
        >
          <Header />
          <Terroir />
          <Histoire />
          <Boutique />
          <References />
          <Contact />
          <div
            style={{
              width: "100%",
              background: "#09090A",
              color: "#CCC",
              // textAlign: "right",
              fontSize: 12,
            }}
          >
            <div style={{ padding: "2px 5px", textAlign: "center" }}>
              Rédaction Marc Galin
            </div>
            <div style={{ padding: "2px 5px", textAlign: "center" }}>
              L'abus d'alcool est dangereux pour la santé, consommez avec
              modération
            </div>
          </div>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js